export enum CardNoteType {
  Scrub = 'Scrub',
  General = 'General',
}
